import { useEffect, useMemo, useState } from "react";
import { useMatch } from "react-router-dom";
import { ActionIcon, TextInput, useMantineTheme } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { IconSearch, IconX } from "@tabler/icons-react";

export const useSearch = () => {
	const theme = useMantineTheme();
	const isWorkOrderSearch = useMatch("/workorders") !== null;
	const isWorkOrderTemplateSearch = useMatch("/workordertemplates") !== null;
	const isWorkOrderScheduleSearch = useMatch("/workorder-schedules") !== null;
	const isCategorySearch = useMatch("/categories") !== null;
	const isLocationSearch = useMatch("/locations") !== null;
	const isAssetSearch = useMatch("/assets") !== null;
	const isUserSearch = useMatch("/users") !== null;
	const isTeamSearch = useMatch("/teams") !== null;
	const isVendorSearch = useMatch("/vendors") !== null;

	let searchContext = "";
	if (isWorkOrderSearch)
		searchContext = "workorders";
	else if (isWorkOrderTemplateSearch) {
		searchContext = "workordertemplates";
	} else if (isWorkOrderScheduleSearch) {
		searchContext = "workorder-schedules";
	} else if (isCategorySearch) {
		searchContext = "categories";
	} else if (isLocationSearch) {
		searchContext = "locations";
	} else if (isAssetSearch) {
		searchContext = "assets";
	} else if (isUserSearch) {
		searchContext = "users";
	} else if (isTeamSearch) {
		searchContext = "teams";
	} else if (isVendorSearch) {
		searchContext = "vendors";
	}

	const [query, setQuery] = useLocalStorage<string>({
		key: `${searchContext}-search`,
		defaultValue: ""
	});

	const [visible, setVisible] = useLocalStorage<boolean>({
		key: `${searchContext}-search-visible`,
		defaultValue: false
	});

	const [searchLabel, setSearchLabel] = useState("Search...");
	useEffect(() => {
		if (isWorkOrderSearch) {
			setSearchLabel("Search work orders...");
		} else if (isWorkOrderTemplateSearch) {
			setSearchLabel("Search work order templates...");
		} else if (isWorkOrderScheduleSearch) {
			setSearchLabel("Search schedules...");
		} else if (isCategorySearch) {
			setSearchLabel("Search categories...");
		} else if (isLocationSearch) {
			setSearchLabel("Search locations...");
		} else if (isAssetSearch) {
			setSearchLabel("Search assets...");
		} else if (isUserSearch) {
			setSearchLabel("Search users...");
		} else if (isTeamSearch) {
			setSearchLabel("Search teams...");
		} else if (isVendorSearch) {
			setSearchLabel("Search vendors...");
		} else {
			setSearchLabel("Search...");
		}
	}, [isWorkOrderSearch, isWorkOrderTemplateSearch, isWorkOrderScheduleSearch, isCategorySearch, isLocationSearch, isAssetSearch, isUserSearch, isTeamSearch, isVendorSearch]);

	const handleSetVisible = (val: boolean) => {
		setVisible(val);
		if (!val) {
			setQuery("");
		}
	}

	const SearchBox = useMemo(() => {
		return searchContext != "" ? <TextInput
			placeholder={searchLabel}
			value={query}
			onChange={(event) => setQuery(event.currentTarget.value)}
			leftSection={<IconSearch size={16} />}
			rightSection={query && <ActionIcon onClick={() => setQuery("")} variant="subtle" radius="xl"><IconX size={16} /></ActionIcon>}
			maw={{ xs: "100%", sm: 400 }}
			radius="md"
		/> : <></>;
	}, [query, searchLabel]);

	return { query, setQuery, visible, setVisible: handleSetVisible, SearchBox, showSearch: searchContext != "" };
}